export default "__VITE_ASSET__RYejaPaB__"